import { createRouter, createWebHistory } from "vue-router";
//import Register from "@/pages/Register.vue";
import Validate from "@/pages/Validate";
import Documents from "@/pages/Documents";
import SetPin from "@/pages/SetPin";
import Questions from "@/pages/Questions";
import Complete from "@/pages/Complete";
import AccountType from "@/pages/account-opening/AccountType";
import HomeOptions from "@/pages/account-opening/HomeOptions";
import CurrencyType from "@/pages/account-opening/CurrencyType";
import ViewAccountApplications from "@/pages/account-opening/view-applications/ViewAccountApplications";
import UpdateT24Documents from "@/pages/account-opening/view-applications/UpdateT24Documents";
import PhoneNumber from "@/pages/account-opening/PhoneNumber";
import CustomerDetails from "@/pages/account-opening/CustomerDetails";
import CurrentCustomerDetails from "@/pages/account-opening/CurrentCustomerDetails";
import RemitCustomerDetails from "@/pages/account-opening/remit/RemitCustomerDetails.vue";
import ISaveFailed from "@/pages/account-opening/ISaveFailed";
import ISaveComplete from "@/pages/account-opening/ISaveComplete";
import T24Complete from "@/pages/account-opening/T24Complete";
import T24Failed from "@/pages/account-opening/T24Failed";
import T24AccountFailed from "@/pages/account-opening/T24AccountFailed";
import ISaveAccountAlreadyExist from "@/pages/account-opening/ISaveAccountAlreadyExist";
import UploadDocuments from "@/pages/account-opening/UploadDocuments";
import UploadDocumentsOptions from "@/pages/account-opening/UploadDocumentsOptions";
import T24UploadDocuments from "@/pages/account-opening/T24UploadDocuments";
import Payments from "@/pages/account-opening/Payments";
import CurrentUploadDocuments from "@/pages/account-opening/CurrentUploadDocuments";
import RemitUploadDocuments from "@/pages/account-opening/remit/RemitAccountUploadDocuments";
//import RemitAccountPayments from "@/pages/account-opening/remit/RemitAccountPayments";
import Login from "@/pages/account-opening/Login";
import Addendum from "@/pages/account-opening/Addendum";
import Signature from "@/pages/account-opening/Signature";
import TermsAndConditions from "@/pages/account-opening/TermsAndConditions";
import ISaveList from "@/pages/account-opening/iSave-upgrade/iSaveList.vue";
import UpgradeISaveTermsAndConditions from "@/pages/account-opening/iSave-upgrade/UpgradeISaveTermsAndConditions.vue";
import UpgradeISaveCustomerDetails from "@/pages/account-opening/iSave-upgrade/UpgradeISaveCustomerDetails.vue";
import UpgradeISaveComplete from "@/pages/account-opening/iSave-upgrade/UpgradeISaveComplete.vue";
//import UpgradePayments from "@/pages/account-opening/iSave-upgrade/UpgradePayments.vue";

import UpgradeISaveUploadDocuments from "@/pages/account-opening/iSave-upgrade/UpgradeISaveUploadDocuments.vue";
import UpgradeISaveSignature from "@/pages/account-opening/iSave-upgrade/UpgradeISaveSignature.vue";
import RemitSignature from "@/pages/account-opening/remit/RemitSignature.vue";
import DiasporaSignature from "@/pages/account-opening/diaspora/DiasporaSignature.vue";
import DiasporaUploadDocuments from "@/pages/account-opening/diaspora/DiasporaUploadDocuments.vue";
import DiasporaCurrencyType from "@/pages/account-opening/diaspora/DiasporaCurrencyType.vue";
import DiasporaCustomerDetails from "@/pages/account-opening/diaspora/DiasporaCustomerDetails.vue";
import DiasporaAccountPayments from "@/pages/account-opening/diaspora/DiasporaAccountPayments.vue";
import BasePage from "@/pages/base/BasePage.vue";
import Main from "../pages/omni-channel/Main.vue";
import LoginComplete from "../pages/omni-channel/LoginComplete.vue";
import LayoutPage from "../pages/omni-channel/base/LayoutPage.vue";
import VerifyPhone from "../pages/omni-channel/VerifyPhone.vue";
import Register from "../pages/omni-channel/Register.vue";
import Home from "../pages/omni-channel/Home.vue";
import TermsConditions from "../pages/omni-channel/TermsAndConditions.vue";
import AccountTypeOmni from "../pages/omni-channel/AccountType.vue";
import SignatureOmni from "../pages/omni-channel/Signature.vue";
import CustomerDetailsOmni from "../pages/omni-channel/CustomerDetails.vue";
import Password from "../pages/omni-channel/Password.vue";
import UploadDocumentsOmni from "../pages/omni-channel/UploadDocuments.vue";
import PaymentOmni from "../pages/omni-channel/Payment.vue";
import ViewApplicationsOmni from "../pages/omni-channel/ViewApplications.vue";

import CustomerSignature from "@/pages/channels/CustomerSignature.vue";
//import CardManagement from "@/pages/channels/cards/CardManagement.vue";
//import ChannelsSubmition from "@/pages/channels/ChannelsSubmition.vue"

const routes = [
  //  {path: '/account-opening', name: 'AccountOpening', component: AccountOpening},
  { path: "/complete/:sdkActionUid", name: "Complete", component: Complete },
  { path: "/questions/:sdkActionUid", name: "Questions", component: Questions },
  { path: "/setpin/:sdkActionUid", name: "SetPin", component: SetPin },
  { path: "/documents/:sdkActionUid", name: "Documents", component: Documents },
  {
    path: "/validate/:sdkActionUid/:registrationType?",
    name: "Validate",
    component: Validate,
  },
  { path: "/register/:sdkActionUid", name: "Register", component: Register },
  {
    path: '/',
    redirect: '/omni',
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/omni',
  },  {
    path: "/omni",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "DefaultMain",
        component: Main,
      },
      {
        path: "main/:channel?/:phone?",
        name: "Default-Main",
        component: Main,
      },
      {
        path: "login-complete/:status?",
        name: "LoginComplete",
        component: LoginComplete,
      },
      {
        path: "verify",
        name: "VerifyPhone",
        component: VerifyPhone,
      },
      {
        path: "register",
        name: "Register",
        component: Register,
      },
      {
        path: "home/:token?",
        name: "Home",
        component: Home,
      },
      {
        path: "terms-and-conditions",
        name: "TermsConditionsOmni",
        component: TermsConditions,
      },
      {
        path: "account-type",
        name: "AccountTypeOmni",
        component: AccountTypeOmni,
      },
      {
        path: "signature",
        name: "SignatureOmni",
        component: SignatureOmni, 
      },
      {
        path: "customer-details",
        name: "CustomerDetailsOmni",
        component: CustomerDetailsOmni, 
      },
      {
        path: "password",
        name: "Password",
        component: Password, 
      },
      {
        path: "upload-documents",
        name: "UploadDocumentsOmni",
        component: UploadDocumentsOmni,
      },
      {
        path: "payment",
        name: "PaymentOmni",
        component: PaymentOmni,
      },
      {
        path: "view-account-applications",
        name: "ViewApplicationsOmni",
        component: ViewApplicationsOmni,
      }
    ]
  },
  {
    path: "/acc",
    component: BasePage,
    children: [
      {
        path: "",
        name: "DefaultLogin",
        component: Login,
      },
      {
        path: "account-type",
        name: "AccountType",
        component: AccountType,
      },
      {
        path: "currency-type",
        name: "CurrencyType",
        component: CurrencyType,
      },
      {
        path: "iSave-list",
        name: "iSaveList",
        component: ISaveList
      },
      {
        path: "home/:token?",
        name: "HomeOptions",
        component: HomeOptions,
      },
      {
        path: "view-account-applications",
        name: "ViewAccountApplications",
        component: ViewAccountApplications,
      },
      {
        path: "update-t24-documents",
        name: "UpdateT24Documents",
        component: UpdateT24Documents,
      },
      {
        path: "phone-number",
        name: "PhoneNumber",
        component: PhoneNumber,
      },
      {
        path: "customer-signature/:sessionUid",
        name: "CustomerSignature",
        component: CustomerSignature,
      },
      {
        path: "customer-details",
        name: "CustomerDetails",
        component: CustomerDetails,
      },
      {
        path: "current-customer-details",
        name: "CurrentCustomerDetails",
        component: CurrentCustomerDetails,
      },
      {
        path: "upload-documents-options",
        name: "UploadDocumentsOptions",
        component: UploadDocumentsOptions,
      },
      {
        path: "payments",
        name: "Payments",
        component: Payments,
      },
      // {
      //   path: "upgrade-payments",
      //   name: "UpgradePayments",
      //   component: UpgradePayments,
      // },

      // {
      //   path: "remit-payments",
      //   name: "RemitAccountPayments",
      //   component: RemitAccountPayments,
      // },
      {
        path: "diaspora-payments",
        name: "DiasporaAccountPayments",
        component: DiasporaAccountPayments,
      },
      // {
      //   path: "remit-upload-documents",
      //   name: "RemitAccountUploadDocuments",
      //   component: RemitAccountUploadDocuments
      // },
      {
        path: "upgrade-iSave-customer-details",
        name: "UpgradeISaveCustomerDetails",
        component: UpgradeISaveCustomerDetails
      },
      {
        path: "remit-customer-details",
        name: "RemitCustomerDetails",
        component: RemitCustomerDetails,
      },
      {
        path: "isave-failed",
        name: "ISaveFailed",
        component: ISaveFailed,
      },
      {
        path: "isave-complete",
        name: "ISaveComplete",
        component: ISaveComplete,
      },
      {
        path: "t24-complete",
        name: "T24Complete",
        component: T24Complete,
      },
      {
        path: "upgrade-iSave-complete",
        name: "UpgradeISaveComplete",
        component: UpgradeISaveComplete
      },
      {
        path: "upload-documents",
        name: "UploadDocuments",
        component: UploadDocuments,
      },
      {
        path: "t24-upload-documents",
        name: "T24UploadDocuments",
        component: T24UploadDocuments,
      },
      {
        path: "current-upload-documents",
        name: "CurrentUploadDocuments",
        component: CurrentUploadDocuments,
      },
      {
        path: "upgrade-iSave-upload-documents",
        name: "UpgradeISaveUploadDocuments",
        component: UpgradeISaveUploadDocuments
      },
      {
        path: "remit-upload-documents",
        name: "RemitUploadDocuments",
        component: RemitUploadDocuments,
      },
      {
        path: "login",
        name: "Login",
        component: Login,
      },
      {
        path: "signature",
        name: "Signature",
        component: Signature,
      },
      {
        path: "remit-signature",
        name: "RemitSignature",
        component: RemitSignature
      },
      {
        path: "diaspora-signature",
        name: "DiasporaSignature",
        component: DiasporaSignature
      },
      {
        path: "diaspora-upload-documents",
        name: "DiasporaUploadDocuments",
        component: DiasporaUploadDocuments,
      },
      {
        path: "upgrade-iSave-signature",
        name: "UpgradeISaveSignature",
        component: UpgradeISaveSignature
      },
      {
        path: "diaspora-currency-type",
        name: "DiasporaCurrencyType",
        component: DiasporaCurrencyType
      },
      {
        path: "diaspora-customer-details",
        name: "DiasporaCustomerDetails",
        component: DiasporaCustomerDetails
      },
      {
        path: "terms-and-conditions",
        name: "TermsAndConditions",
        component: TermsAndConditions,
      },
      {
        path: "upgrade-iSave-terms-and-conditions",
        name: "UpgradeISaveTermsAndConditions",
        component: UpgradeISaveTermsAndConditions
      },
      {
        path: "addendum",
        name: "Addendum",
        component: Addendum,
      },
      {
        path: "t24-failed",
        name: "T24 Failed",
        component: T24Failed,
      },
      {
        path: "t24-account-failed",
        name: "T24 Account Failed",
        component: T24AccountFailed,
      },
      {
        path: "iSave-account-already-exist",
        name: "iSave Account Already Exist",
        component: ISaveAccountAlreadyExist,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes, // short for `routes: routes`
});

export default router;
